module.exports = __webpack_public_path__ + "static/media/deftness.31accc50.png";